// Identity query (me.rs: GET /v1/me → kore's IdentityRs). Subject and name
// always; email only when the gateway forwarded it (absent in local dev).

import { queryOptions, useQuery } from "@tanstack/react-query";
import { http } from "./http";
import type { IdentityRs } from "./types";

// User-scoped like ["workspaces"]; tenant-switch eviction refetching it is
// harmless.
export const identityQueryOptions = queryOptions({
    queryKey: ["me"],
    queryFn: () => http.get<IdentityRs>("/v1/me"),
    // Fresh enough for the header; short enough that a session change is
    // noticed on tab return.
    staleTime: 5 * 60 * 1000,
});

export function useIdentity() {
    return useQuery(identityQueryOptions);
}
